import { createTheme } from '@one-thd/sui-atomic-components';

const HouseStyleSecondaryLightYellow = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

HouseStyleSecondaryLightYellow.palette['--sui-palette-background-primary'] = '254 212 88';

export { HouseStyleSecondaryLightYellow };